import React from 'react'

const Bulletins = () => {
  return (
    <div>Bulletins</div>
  )
}

export default Bulletins